import React from 'react';
import PropTypes from 'prop-types';
import prettierBytes from 'prettier-bytes';
import { MIME_TYPE_TO_DISPLAY_NAME } from '@medflex/utils/constants';
import RenderFileIconModule from '../RenderFileIconModule';

const mimeType2displayName = mimeType => MIME_TYPE_TO_DISPLAY_NAME[mimeType] || mimeType;

const FileMessage = ({ message, clickHandler }) => {
  const files = message.files || [message.file];
  const createClickHandler = file => e => {
    e.preventDefault();
    clickHandler(file);
  };

  return (
    <>
      {message.text && <div className="pb-4">{message.text}</div>}
      <ul className="flex flex-col space-y-4">
        {files.map(file => (
          <div key={`FileMessage_File${file.id}`} className="flex">
            <button
              type="button"
              className="focus:outline-none truncate max-w-full flex flex-row items-center"
              onClick={createClickHandler(file)}
            >
              <div className="text-green-500 flex">
                <RenderFileIconModule mime={file.mediaType} />
              </div>
              <div className="mx-3 overflow-hidden flex flex-col items-start">
                <div className="whitespace-normal text-left break-all text-slate-900 hover:underline focus:underline">
                  {file.name}
                </div>

                <p className="text-slate-500 text-sm">
                  <span>{prettierBytes(file.bytes)}</span>
                  <span className="px-1">/</span>
                  <span>{mimeType2displayName(file.mediaType)}</span>
                </p>
              </div>
            </button>
          </div>
        ))}
      </ul>
    </>
  );
};

FileMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    isSender: PropTypes.bool,
    text: PropTypes.string,
    file: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      mediaType: PropTypes.string,
      bytes: PropTypes.number,
    }),
    files: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        mediaType: PropTypes.string,
        bytes: PropTypes.number,
      }),
    ),
  }),
  clickHandler: PropTypes.func.isRequired,
};

export default FileMessage;
